import { type Theme, teamsHighContrastTheme } from '@fluentui/react-components';
import type { TeamsTheme } from '#src/teams/teams-host';
import { darkTheme, lightTheme } from '#src/theme/identity';

/** O que a pessoa escolheu em Configurações. */
export type ThemePreference = 'system' | 'light' | 'dark';

export const THEME_PREFERENCES: readonly ThemePreference[] = [
  'system',
  'light',
  'dark',
];

/** O tema em uso. No alto contraste, as cores da identidade dão lugar às do sistema. */
export type ThemeMode = 'light' | 'dark' | 'contrast';

/**
 * Claro e escuro com a identidade do app (azul-marinho), gerados pelas
 * mesmas funções dos temas do Teams; alto contraste, o do Teams.
 */
export const THEMES: Record<ThemeMode, Theme> = {
  light: lightTheme,
  dark: darkTheme,
  contrast: teamsHighContrastTheme,
};

export interface ThemeInputs {
  readonly preference: ThemePreference;
  /** Tema do Teams, quando a aplicação roda dentro dele. */
  readonly teamsTheme: TeamsTheme | null;
  readonly systemPrefersDark: boolean;
}

/**
 * Escolha explícita da pessoa vence. Em "sistema", dentro do Teams vale o
 * tema do Teams (inclusive alto contraste); fora dele, o do sistema operacional.
 */
export function resolveThemeMode({
  preference,
  teamsTheme,
  systemPrefersDark,
}: ThemeInputs): ThemeMode {
  if (preference !== 'system') {
    return preference;
  }
  if (teamsTheme === 'contrast') {
    return 'contrast';
  }
  const dark = teamsTheme === null ? systemPrefersDark : teamsTheme === 'dark';
  return dark ? 'dark' : 'light';
}
